// src/components/comments/Comment.tsx
import { CommentProps } from '@/types';

const Comment: React.FC<CommentProps> = ({ comentario, puntuacion, creado_en, usuario }) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-4 mb-4">
      
      {/* 🔹 Encabezado: usuario, puntuación y fecha */}
      <div className="flex items-center mb-2">
        <strong className='text-zinc-600'>{usuario}</strong> {/* 🟢 Nombre del usuario */}
        
        <span className="ml-4 text-yellow-500">
          {"★".repeat(puntuacion)} {/* 🟢 Puntuación como estrellas */}
        </span>

        <span className="ml-auto text-zinc-600 text-sm">
          {new Date(creado_en).toLocaleDateString()} {/* 🟢 Fecha formateada */}
        </span>
      </div>

      {/* 🔹 Cuerpo del comentario */}
      <p className='text-zinc-600'>{comentario}</p>
    </div>
  );
};

export default Comment;
